//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { date } from "quasar";
import { mapState, mapActions } from "vuex";
import router from "../../../router";

export default {
  props: {
    article: {},
  },

  data() {
    return {
      columns: [
        {
          name: "orderDate",
          align: "left",
          label: this.$t("order.orderDate"),
          field: "orderDate",
          format: (val) => date.formatDate(val, "DD-MM-YYYY"),
          sortable: true,
        },
        {
          name: "orderNumber",
          align: "left",
          label: this.$t("order.orderNo"),
          field: "orderNumber",
          sortable: true,
        },
        {
          name: "customerName",
          align: "left",
          label: this.$t("order.customer"),
          field: "customerName",
          sortable: true,
        },
        {
          name: "packedDate",
          align: "left",
          label: "Pakket dato",
          field: "packedDate",
          format: (val) => date.formatDate(val, "DD-MM-YYYY"),
          sortable: true,
        },
        {
          name: "numberOfItems",
          align: "right",
          label: this.$t("order.quantity"),
          field: "numberOfItems",
          sortable: true,
        },
        {
          name: "numberOfReceivedOrPicked",
          align: "right",
          label: this.$t("order.delivered"),
          field: "numberOfReceivedOrPicked",
          sortable: true,
        },
      ],

      dense: true,
      orderItems: [],
      hideTableBottom: true,
      totalPicked: 0,
      totalValue: 0,
    };
  },

  async mounted() {
    await this.refresh();
  },

  computed: {
    ...mapState("main", []),
  },

  methods: {
    ...mapActions("main", ["getCustomerOrderItemsByProductAndPeriod"]),

    async refresh() {
      if (!this.article.fromDate || !this.article.toDate) {
        let dateEnd = new Date();
        this.article.toDate = date.formatDate(dateEnd, "DD-MM-YYYY");
        let dateStart = date.subtractFromDate(dateEnd, { month: 3 });
        this.article.fromDate = date.formatDate(dateStart, "DD-MM-YYYY");
      }
      this.getCustomerOrderItems();
    },

    async getCustomerOrderItems() {
      if (this.article.fromDate && this.article.toDate) {
        this.orderItems = await this.getCustomerOrderItemsByProductAndPeriod({
          productId: this.article.id,
          fromDate: this.toEngFormat(this.article.fromDate),
          toDate: this.toEngFormat(this.article.toDate),
        });
        this.calculateTotalSum();
      } else {
        this.orderItems = [];
        this.totalValue = 0;
        this.totalPicked = 0;
      }
    },

    calculateTotalSum() {
      this.totalValue = 0;
      this.totalPicked = 0;
      for (var i = 0; i < this.orderItems.length; i++) {
        this.totalValue += this.orderItems[i].numberOfItems;
        this.totalPicked += this.orderItems[i].numberOfReceivedOrPicked;
      }
    },

    openCustomerOrder(orderId) {
      router.push({ name: "Order", params: { id: orderId } });
    },

    async hideFromDate(pdate) {
      pdate.hide();
      this.fromDateChanged();
    },

    async hideToDate(pdate) {
      pdate.hide();
      this.toDateChanged();
    },

    async fromDateChanged() {
      this.article.fromDate = this.autoCompleteDate(this.article.fromDate);
      this.getCustomerOrderItems();
    },

    async toDateChanged() {
      this.article.toDate = this.autoCompleteDate(this.article.toDate);
      this.getCustomerOrderItems();
    },

    toEngFormat(strDate) {
      var splitDate = strDate.split("-");
      return splitDate[2] + "-" + splitDate[1] + "-" + splitDate[0];
    },

    autoCompleteDate(strDate) {
      if (strDate.length > 0 && strDate.length < 7) {
        if (isNaN(parseInt(strDate))) return "";
        try {
          if (strDate.length < 6) {
            let today = new Date();
            if (strDate.length == 1)
              strDate = "0" + strDate + date.formatDate(today, "MMYY");
            else if (strDate.length == 2)
              strDate = strDate + date.formatDate(today, "MMYY");
            else if (strDate.length == 3) {
              strDate = strDate.substring(0, 2) + "0" + strDate.substring(2, 3);
              strDate = strDate + date.formatDate(today, "YY");
            } else if (strDate.length == 4)
              strDate = strDate + date.formatDate(today, "YY");
            else if (strDate.length == 5) {
              strDate = strDate.substring(0, 4);
              strDate = strDate + date.formatDate(today, "YY");
            }
          }

          let newDate = date.extractDate(strDate, "DDMMYY");
          return date.formatDate(newDate, "DD-MM-YYYY");
        } catch (error) {
          return "";
        }
      }
      return strDate;
    },
  },
};
